export default {
  UPDATE_NOTIFICATION_LIST: (state, payload) => {
    state.notificationList = payload
  }
  
}